var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpenses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#FABB06"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 20,
    fill: "#FFA902"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1447_6926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5 20H19.1667C18.4508 20 17.7733 19.69 17.3042 19.1675C17.7625 18.6558 18.4283 18.3333 19.1667 18.3333H34.1667C35.2567 18.3283 35.2558 16.6708 34.1667 16.6666H19.1667C16.8658 16.6666 15 18.5325 15 20.8333V29.1666C15 31.4675 16.8658 33.3333 19.1667 33.3333H32.5C33.8808 33.3333 35 32.2141 35 30.8333V22.5C35 21.1191 33.8808 20 32.5 20ZM31.6667 27.5C30.5767 27.495 30.5767 25.8383 31.6667 25.8333C32.7567 25.8383 32.7567 27.495 31.6667 27.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1447_6926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenses);
export default __webpack_public_path__ + "static/media/expenses.185832c54649ed3ab822b9f4f69cfe95.svg";
export { ForwardRef as ReactComponent };